export const SET_LANDING_PAGE = "setLandingPage";
